import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@johnlewispartnership/wtr-ingredients/ingredients/Tooltip';
import Modal from 'react-modal';

import MyWaitrosePopOver from 'components/Product/MyWaitrosePopover';
import styles from 'components/PopOver/PopOver.scss';

const PopOver = ({ promotion }) => {
  const [popOverOpen, setPopOverOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const openPopover = useCallback(() => {
    setPopOverOpen(true);
  }, []);

  const closePopover = useCallback(() => {
    setPopOverOpen(false);
  }, []);

  const toggleModal = useCallback(() => {
    setModalOpen(currentModalOpen => !currentModalOpen);
  }, []);

  return (
    <div className={styles.popOver}>
      <div className={`visible-sm-inline visible-md-inline visible-lg-inline visible-xl-inline`}>
        <Tooltip
          content={<MyWaitrosePopOver closeButton={closePopover} promotion={promotion} />}
          className={styles.popoverContentRight}
          isOpen={popOverOpen}
          placement="right"
          distanceOffset={12}
          onClose={closePopover}
          disableFocusListener
          disableHoverListener
        >
          <div
            className={styles.myWpopOverBtn}
            onClick={openPopover}
            data-testid="btn-mywaitrose-popover-desktop"
          />
        </Tooltip>
      </div>
      <div className={`visible-xs-inline`}>
        <div
          className={styles.myWpopOverBtn}
          onClick={toggleModal}
          data-testid="btn-mywaitrose-popover-mobile"
        />
        <Modal
          className={styles.modal}
          isOpen={modalOpen}
          onRequestClose={toggleModal}
          overlayClassName={styles.background}
          shouldCloseOnOverlayClick
        >
          <MyWaitrosePopOver closeButton={toggleModal} promotion={promotion} />
        </Modal>
      </div>
    </div>
  );
};

PopOver.propTypes = {
  promotion: PropTypes.shape({}).isRequired,
};

export default PopOver;
